module.exports = __webpack_public_path__ + "static/media/helper.c46e6a03.svg";